<!--
 * @LastEditTime: 2022-12-02 16:42:37
 * @LastEditors: Please set LastEditors
 * @Description: 服务商入驻租赁通申请 审核页
-->
<template>
	<div class="service-provider-layout">
		<div class="service-content">
			<div class="authentication">服务商入驻租赁通申请（企业）</div>
			<el-row>
				<el-col :span="23" :offset="1">
					<el-form ref="applyForm" :model="applyForm" label-width="140px" label-position="left" size="small">
						<!-- 个人认证基本信息 -->
						<div class="person-service mt40">
							<el-row :gutter="40">
								<template v-if="applyForm.creType == 0">
									<el-col :span="4">
										<div class="upload-image">
											<public-upload
												ref="yyzzUpload"
												isViewMode
												width="200px"
												:viewFilesList="businessList"
												listType="picture-card"
											></public-upload>
											<div class="top-item-text2">企业证件</div>
										</div>
									</el-col>
									<el-col :span="4">
										<div class="upload-image">
											<public-upload
												ref="ywzzxkUpload"
												isViewMode
												width="200px"
												:viewFilesList="logoList"
												listType="picture-card"
											></public-upload>
											<div class="top-item-text2">企业LOGO</div>
										</div>
									</el-col>
								</template>
								<template v-else>
									<el-col :span="4">
										<div class="upload-image">
											<public-upload
												ref="yyzzUpload"
												isViewMode
												width="200px"
												:viewFilesList="businessList"
												listType="picture-card"
											></public-upload>
											<div class="top-item-text2">企业证件</div>
										</div>
									</el-col>
									<el-col :span="4">
										<div class="upload-image">
											<public-upload
												ref="yyzzUpload"
												isViewMode
												width="200px"
												:viewFilesList="ghList"
												listType="picture-card"
											></public-upload>
											<div class="top-item-text2">代理人身份证（国徽面）</div>
										</div>
									</el-col>
									<el-col :span="4">
										<div class="upload-image">
											<public-upload
												ref="yyzzUpload"
												isViewMode
												width="200px"
												:viewFilesList="rxList"
												listType="picture-card"
											></public-upload>
											<div class="top-item-text2">代理人身份证（人像面）</div>
										</div>
									</el-col>
									<el-col :span="4">
										<div class="upload-image">
											<public-upload
												ref="yyzzUpload"
												isViewMode
												width="200px"
												:viewFilesList="qywtList"
												listType="picture-card"
											></public-upload>
											<div class="top-item-text2">企业委托书（盖章）</div>
										</div>
									</el-col>
									<el-col :span="4">
										<div class="upload-image">
											<public-upload
												ref="yyzzUpload"
												isViewMode
												width="200px"
												:viewFilesList="logoList"
												listType="picture-card"
											></public-upload>
											<div class="top-item-text2">企业LOGO</div>
										</div>
									</el-col>
								</template>
							</el-row>
							<template v-if="applyForm.creType == 0">
								<el-row>
									<el-col :span="9">
										<el-form-item label="企业名称：">
											<span>{{ applyForm.sname }}</span>
										</el-form-item>
									</el-col>
									<el-col :span="9">
										<el-form-item label="统一社会信用代码：">
											<span>{{ applyForm.creditCode }}</span>
										</el-form-item>
									</el-col>
								</el-row>
								<el-row>
									<el-col :span="9">
										<el-form-item label="单位类型：">
											<span>{{ applyForm.flatTypeName }}</span>
										</el-form-item>
									</el-col>
								</el-row>
								<el-row>
									<el-col :span="9">
										<el-form-item label="法人代表：">
											<span>{{ applyForm.legal }}</span>
										</el-form-item>
									</el-col>
									<el-col :span="9">
										<el-form-item label="法人代表手机号：">
											<span>{{ applyForm.legalPhone }}</span>
										</el-form-item>
									</el-col>
								</el-row>
								<el-row>
									<el-col :span="9">
										<el-form-item label="法人代表证件类型：">
											<span>{{ applyForm.cardTypeName }}</span>
										</el-form-item>
									</el-col>
									<el-col :span="9">
										<el-form-item label="法人代表证件号码：">
											<span>{{ applyForm.legalNo }}</span>
										</el-form-item>
									</el-col>
								</el-row>
								<el-row>
									<el-col :span="9">
										<el-form-item label="公司简称：">
											<span>{{ applyForm.shortName }}</span>
										</el-form-item>
									</el-col>
									<el-col :span="9">
										<el-form-item label="注册地址：">
											<span>{{ applyForm.registAdd }}</span>
										</el-form-item>
									</el-col>
								</el-row>
							</template>
							<template v-else>
								<el-row>
									<el-col :span="9">
										<el-form-item label="企业名称：">
											<span>{{ applyForm.sname }}</span>
										</el-form-item>
									</el-col>
									<el-col :span="9">
										<el-form-item label="统一社会信用代码：">
											<span>{{ applyForm.creditCode }}</span>
										</el-form-item>
									</el-col>
								</el-row>
								<el-row>
									<el-col :span="9">
										<el-form-item label="单位类型：">
											<span>{{ applyForm.flatTypeName }}</span>
										</el-form-item>
									</el-col>
									<el-col :span="9">
										<el-form-item label="法人代表姓名：">
											<span>{{ applyForm.legal }}</span>
										</el-form-item>
									</el-col>
								</el-row>
								<el-row>
									<el-col :span="9">
										<el-form-item label="法人代表手机号">
											<span>{{ applyForm.legalPhone }}</span>
										</el-form-item>
									</el-col>
									<el-col :span="9">
										<el-form-item label="代理人姓名：">
											<span>{{ applyForm.agent }}</span>
										</el-form-item>
									</el-col>
								</el-row>
								<el-row>
									<el-col :span="9">
										<el-form-item label="代理人身份证号：">
											<span>{{ applyForm.agentNo }}</span>
										</el-form-item>
									</el-col>
									<el-col :span="9">
										<el-form-item label="代理人手机号：">
											<span>{{ applyForm.agentPhone }}</span>
										</el-form-item>
									</el-col>
								</el-row>
								<el-row>
									<el-col :span="9">
										<el-form-item label="公司简称：">
											<span>{{ applyForm.shortName }}</span>
										</el-form-item>
									</el-col>
									<el-col :span="9">
										<el-form-item label="注册地址：">
											<span>{{ applyForm.registAdd }}</span>
										</el-form-item>
									</el-col>
								</el-row>
							</template>
						</div>
						<!-- 企业营业执照 -->
						<el-row :gutter="40">
							<el-col :span="4">
								<div class="upload-image">
									<public-upload ref="yyzzUpload" isViewMode :viewFilesList="jyzzList" listType="picture-card"></public-upload>
									<div class="top-item-text2">租赁业务资质许可</div>
								</div>
							</el-col>
							<el-col :span="4">
								<div class="upload-image">
									<public-upload ref="ywzzxkUpload" isViewMode :viewFilesList="aqscList" listType="picture-card"></public-upload>
									<div class="top-item-text2">安全生产许可证</div>
								</div>
							</el-col>
						</el-row>
						<el-row>
							<el-col :span="24">
								<el-form-item label="备注说明：">
									{{ applyForm.bzsm }}
								</el-form-item>
							</el-col>
						</el-row>
					</el-form>
				</el-col>
			</el-row>
			<el-row>
				<el-col :span="24" class="mt20">
					<p>审核记录：</p>
					<vxe-table
						align="center"
						auto-resize
						border
						class="mt20"
						:data="checkData"
						highlight-current-row
						highlight-hover-row
						show-overflow="tooltip"
						show-header-overflow="tooltip"
					>
						<vxe-table-column field="status" title="审核结果">
							<template #default="{ row }">
								<span v-if="row.status == 1">通过</span>
								<span v-else-if="row.status == 2">驳回</span>
							</template>
						</vxe-table-column>
						<vxe-table-column field="upUserSname" title="审核人"></vxe-table-column>
						<vxe-table-column field="updateDate" title="审核时间"></vxe-table-column>
						<vxe-table-column field="remark" title="备注"></vxe-table-column>
					</vxe-table>
				</el-col>
			</el-row>
		</div>
		<div class="footer text-center" :class="{ hidden: mode == 'view' }">
			<el-button icon="el-icon-edit-outline" size="mini" @click="auditDialog">审核</el-button>
		</div>
	</div>
</template>
<script>
import * as API from 'api/modules/audit'
export default {
	components: {},
	props: {
		companyId: {
			type: String,
			default: ''
		},
		rowData: {
			type: Object,
			default: () => {
				return {}
			}
		}
	},
	filters: {
		timeFilter(val) {
			if (val) {
				return val.split(' ')[0]
			}
		}
	},
	data() {
		return {
			// 企业/个人服务商认证基本资料
			applyForm: {},
			checkData: [], //审核记录
			businessList: [], //企业营业执照图片
			logoList: [], //logo图片
			ghList: [], //身份证国徽面图片
			rxList: [], //身份证人像面图片
			qywtList: [], //企业委托书图片
			aqscList: [], //安全生产图片
			jyzzList: [] //租赁业务资质许可
		}
	},
	created() {
		this.companyId != '' ? this.getCompanyMsg() : this.goBack()
	},
	methods: {
		// 查询企业/个人服务商认证资料
		getCompanyMsg() {
			API.getRecordDetail({
				recordId: this.rowData.id,
				id: this.rowData.id
			}).then((res) => {
				this.applyForm = this.$utils.clone(res.data, true)
				this.businessList = res.data.yyzz
				this.logoList = res.data.logo
				this.ghList = res.data.gh
				this.rxList = res.data.rx
				this.qywtList = res.data.qywts
				this.aqscList = res.data.aqsc
				this.jyzzList = res.data.jyzz
				// 审核记录 -- 2025-09-19 替换以前的单独接口
				this.checkData = res.data.applyRecords || []
			})
		},

		// 审查页返回审计代办页
		goBack() {
			this.$router.push({ path: '/audit-affairs-new' })
		},

		// 审查弹框
		auditDialog() {
			let params = {
				id: this.rowData.id,
				busId: this.rowData.busId
			}
			this.$emit('openDia', params)
		}
	},
	computed: {
		mode() {
			return this.$route.query.mode
		}
	}
}
</script>
<style lang="less" scoped>
.service-provider-layout {
	height: 100%;
	overflow-y: auto;
	.service-content {
		padding: 30px 20px;
		position: relative;
		.authentication {
			width: 1000px;
			height: 45px;
			line-height: 45px;
			font-size: 16px;
			font-weight: 600;
			text-align: center;
		}
		.mt40 {
			margin-top: 40px;
		}
		.top-item-text2 {
			font-size: 12px;
			line-height: 30px;
			color: #666;
			text-align: center;
		}
	}
	.footer {
		position: absolute;
		top: 88px;
		right: 135px;
		.el-button {
			height: 28px !important;
		}
	}
}
.upload-image {
	max-width: 200px;
}
/deep/.el-form-item__content {
	word-break: break-all;
}
</style>
